import { put, takeLatest, call, select } from 'redux-saga/effects';

import ResearchersPage, { Researcher } from '@interfaces/researchers-page';
import { redirectToNotFound } from 'client/helpers/redirectTo';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';
import * as selectors from './selectors';

function* fetchResearchersPage(action: any) {
    try {
        const { page } = action.payload;

        const status = yield select(selectors.getStatusBySelectedTab);
        const themeSlug = yield select(selectors.getSelectedThemeSlug);

        const data: ResearchersPage = yield call(service.fetchResearchersPage, { page, themeSlug, status });

        yield put(actions.fetchResearchersPageSuccess(data));
    } catch (error) {
        yield put(actions.fetchResearchersPageError(error.message));
    }
}

function* fetchResearcher(action: any) {
    try {
        const { id } = action.payload;
        const data: Researcher = yield call(service.fetchResearcher, id);

        yield put(actions.fetchResearcherSuccess(data));
    } catch (error) {
        yield put(actions.fetchResearcherError(error.message));
        yield put(redirectToNotFound());
    }
}

export default function* appSaga() {
    yield takeLatest(types.FETCH_RESEARCHERS_PAGE, fetchResearchersPage);
    yield takeLatest(types.FETCH_RESEARCHER, fetchResearcher);
}
